module.exports = __webpack_public_path__ + "img/nav1_h.cc0f02de.png";